import Sidebar from '../Sidebar/Sidebar';
import './DeviceReports.css'

import { useNavigate } from 'react-router-dom';
import { FloatButton, Checkbox, Spin, Pagination, Empty, Modal, Input, Form, Button, message, Popconfirm, Row, Col, Divider, DatePicker, Tooltip as AntdTooltip, Select, Tooltip } from 'antd';
import { FilePdfOutlined, FileExcelOutlined, ExportOutlined, EyeOutlined, SortDescendingOutlined, SortAscendingOutlined, EditOutlined } from '@ant-design/icons';
import { useState, useEffect, useCallback } from 'react';
import jsPDF from 'jspdf';
// import axios from 'axios';
// QR codes ZIP
import QRCode from "qrcode";
import JSZip from "jszip";
import { saveAs } from "file-saver";
import search from '../Dashboard/assets/img/search.png';
import SignInToHighLevel from '../../gohighlevel/SignInToHighLevel';
import axiosApi from '../../axiosApi/axiosApi';
import axios from 'axios';
import { Option } from 'antd/es/mentions';
const { RangePicker } = DatePicker;

function DeviceReports() {
 const navigate = useNavigate();
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(true);
  const [checkedItems, setCheckedItems] = useState({});
  const [searchQuery, setSearchQuery] = useState('');
  const [dateRange, setDateRange] = useState([null, null]);
  const [selectAll, setSelectAll] = useState(false);
  const [isGolevelSignedIn, setIsGolevelSignedIn] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [selectedFields, setSelectedFields] = useState([]);
  const [selectAllFields, setSelectAllFields] = useState(false);
  
  // States for Pagination
  const [currentPage, setCurrentPage] = useState(1);
  const [totalReports, setTotalReports] = useState(0);
  const [isGhlLoading, setIsGhlLoading] = useState(false);
  const [publishedReports, setPublishedReports] = useState([]);
  const [sortOrder, setSortOrder] = useState('desc');
  const [selectedFilter, setSelectedFilter] = useState(null);
  const [filterValue, setFilterValue] = useState('');
  const reportsPerPage = 10;
  
  // State for modal visibility and selected report
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedReport, setSelectedReport] = useState(null);
  const [form] = Form.useForm();
  const role = localStorage.getItem('role') || '';

  // Cache for visited pages
  const [pageCache, setPageCache] = useState(new Map());

  // Debounce search
  const [searchTimeout, setSearchTimeout] = useState(null);

  // Function to open report details in a new tab
  function openReportDetails(reportId) {
    window.open(`/report/${reportId}`, '_blank');
  }

  // Create cache key for current filters
  const getCacheKey = useCallback(() => {
    return `${currentPage}-${reportsPerPage}-${searchQuery}-${filterValue}-${dateRange[0]?.format('YYYY-MM-DD') || ''}-${dateRange[1]?.format('YYYY-MM-DD') || ''}`;
  }, [currentPage, reportsPerPage, searchQuery, filterValue, dateRange]);

  // Fetch reports from the API with pagination and filters

    const filterOptions = {
    brand: [],
    model: [],
    grade: [],
    inStock: ['Yes', 'NO'],
    status: ['Completed', 'Not Completed'],
  };
  const fetchReports = async (page = currentPage, search = searchQuery, selectedFilt = filterValue, dateFilter = dateRange, sort = "desc") => {

    setLoading(true);
    try {
      // Check cache first
      const cacheKey = `${page}-${reportsPerPage}-${search}-${selectedFilt}-${dateFilter[0]?.format('YYYY-MM-DD') || ''}-${dateFilter[1]?.format('YYYY-MM-DD') || ''}`;
      
      if (pageCache.has(cacheKey)) {
        const cachedData = pageCache.get(cacheKey);
        setReports(cachedData.reports);
        setTotalReports(cachedData.totalReports);
        setLoading(false);
        return;
      }

     const params = {
        page,
        limit: reportsPerPage,
        sortOrder:sort,
        selectedFilter: selectedFilter, 
        status: selectedFilt,
      };


      // Add search query if present
      if (search && search.trim()) {
        params.search = search.trim();
      }

      // Add date range if present
      if (dateFilter[0] && dateFilter[1]) {
        params.startDate = dateFilter[0].format('YYYY-MM-DD');
        params.endDate = dateFilter[1].format('YYYY-MM-DD');
      }

      // const response = await axios.get('/api/reports/dashboard', { params });
      const response = await axios.get('/api/reports/dashboard', { params });
       
      // Process reports data
      const fetchedReports = response?.data?.reports.map((report) => ({
        reportId: report.data.report.reportid,
        reportDate: report.data.report.finishtime,
        imei: report.data.report.IMEI,
        brand: report.data.report.Manufacturer,
        model: report.data.report.Model,
        value: report.data.report.value,
        grade: report.data.report.grade,
        reason: report.data.report.reason || 'N/A',
        imageLink: report.data.report.imageLink || '',
        videoLink: report.data.report.videoLink || '',
        sku: report.data.report.sku,
        status: report.data.report.reportstatus,
        inStock: report.data.report.inStock,
      }));

      setReports(fetchedReports);
      setTotalReports(response.data.totalReports);

      // Cache the results
      setPageCache(prev => {
        const newCache = new Map(prev);
        newCache.set(cacheKey, {
          reports: fetchedReports,
          totalReports: response.data.totalReports
        });
        
        // Limit cache size to prevent memory issues (keep last 20 pages)
        if (newCache.size > 20) {
          const firstKey = newCache.keys().next().value;
          newCache.delete(firstKey);
        }
        
        return newCache;
      });

      // Initialize checkbox state
      const initialCheckedState = fetchedReports.reduce((acc, report) => {
        acc[report.reportId] = false;
        return acc;
      }, {});
      setCheckedItems(initialCheckedState);

      console.log("Fetched Reports", fetchedReports);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching reports:', error);
      setLoading(false);
      message.error('Failed to fetch reports');
    }
  };

  // Initial load
  useEffect(() => {
    fetchReports();
  }, []);

  const handleCheckboxChange = (reportId) => {
    setCheckedItems((prevState) => ({
      ...prevState,
      [reportId]: !prevState[reportId],
    }));
  };

const handleSearchChange = (e) => {
  const value = e.target.value;

    setSearchQuery(value);

    // Clear any existing debounce timer
    if (searchTimeout) {
      clearTimeout(searchTimeout);
    }

    // Set a new debounce timer
    const newTimeout = setTimeout(() => {
      setCurrentPage(1);              // Reset to page 1
      setPageCache(new Map());        // Clear paginated cache
      setSortOrder('asc')
      fetchReports(1, value, filterValue, dateRange, 'asc');
    }, 500); // 500ms debounce

    setSearchTimeout(newTimeout);
};


  // Handle date range change
  const handleDateRangeChange = (dates) => {
    setDateRange(dates || [null, null]);
    setCurrentPage(1);
    setPageCache(new Map()); // Clear cache when date range changes
    setSortOrder('asc')
    fetchReports(1, searchQuery, filterValue, dates || [null, null], 'asc');
  };

  // Handle "Select All" for the current page
  const handleSelectAll = () => {
    const newCheckedItems = { ...checkedItems };
    if (selectAll) {
      // Unselect all reports on the current page
      reports.forEach((report) => {
        delete newCheckedItems[report.reportId];
      });
    } else {
      // Select all reports on the current page
      reports.forEach((report) => {
        newCheckedItems[report.reportId] = true;
      });
    }
    setCheckedItems(newCheckedItems);
    setSelectAll(!selectAll);
  };

  // Handle page change
  const handlePageChange = (page) => {
    setCurrentPage(page);
    fetchReports(page, searchQuery,sortOrder, dateRange);
  };

  // Function to fetch and format report details by IMEI
  const fetchReportDetails = async (reportId) => {
    try {
      const response = await axiosApi.get(`/report/${reportId}`);
      const { report, extra } = response.data.data;
      

      // Extracting deeply nested values safely
      const partsReplaced = extra.json.PartsReplaced?.iOS || {};
      const batteryInfo = extra.json.DeviceInfo?.BatteryInfo[0] || {};

      return {
        reportId: report.reportid,
        startTime: report.starttime,
        finishTime: report.finishtime,
        imei: report.IMEI,
        serialNumber: report.serialnumber,
        deviceId: report.deviceid || 'N/A',
        manufacturer: report.Manufacturer,
        model: report.Model,
        os: report.os,
        operator: report.operator,
        reportStatus: report.reportstatus,
        reportResult: report.reportresult,
        reportType: report.reporttype,
        action: report.action,
        value: report.value || 'N/A',
        grade: report.grade || 'N/A',
        inStock:report.inStock || 'YES',

        // Device Info
        countryOrigin: extra.json.DeviceInfo?.CountryOrigin || 'N/A',
        cpu: extra.json.DeviceInfo?.CpuName || 'N/A',
        cpuSpeed: extra.json.DeviceInfo?.CpuSpeed || 'N/A',
        ram: extra.json.DeviceInfo?.RAM || 'N/A',
        memorySize: extra.json.DeviceInfo?.HandsetMemorySize || 'N/A',
        deviceColor: extra.json.DeviceInfo?.DeviceColor || 'N/A',
        lcdResolution: extra.json.DeviceInfo?.LCDResolution || 'N/A',
        lcdSize: extra.json.DeviceInfo?.LCDSize || 'N/A',
        mdmStatus: extra.json.DeviceInfo?.MDMStatus || 'N/A',
        manufactureDate: extra.json.DeviceInfo?.ManufactureDate || 'N/A',
        productVersion: extra.json.DeviceInfo?.ProductVersion || 'N/A',
        originalProductVersion: extra.json.DeviceInfo?.OriginalProductVersion || 'N/A',
        softwareBuild: extra.json.DeviceInfo?.SoftwareBuild || 'N/A',
        rooted: extra.json.DeviceInfo?.Rooted || 'N/A',

        // Battery Info
        batteryHealth: batteryInfo.BatteryHealth || 'N/A',
        batteryCycleCount: batteryInfo.BatteryCycleCount || 'N/A',
        batteryGrading: batteryInfo.BatteryGrading || 'N/A',
        batteryFullChargeCapacity: batteryInfo.BatteryFullChargeCapacity || 'N/A',
        batteryDesignCapacity: batteryInfo.BatteryDesignCapacity || 'N/A',
        batterySerial: batteryInfo.BatterySerial || 'N/A',
        batteryTemp: batteryInfo.BatteryTemp || 'N/A',

        // Wipe Info
        wipeMethod: extra.json.DataWipeInfo?.WipeMethod || 'N/A',
        wipeStatus: extra.json.DataWipeInfo?.Status || 'N/A',

        // Analyst Info
        analystId: extra.json.AnalystInfo?.AnalystId || 'N/A',
        analystAppVersion: extra.json.AnalystInfo?.AnalystApplicationVersion || 'N/A',
        licenseId: extra.json.AnalystInfo?.LicenseId || 'N/A',
        licenseReportMode: extra.json.AnalystInfo?.LicenseReportMode || 'N/A',
        siteId: extra.json.AnalystInfo?.SiteID || 'N/A',
        profileName: extra.json.AnalystInfo?.ProfileName || 'N/A',
        testCaseFails: extra.json.AnalystInfo?.TestCaseFails || 'N/A',
        windowsPCName: extra.json.AnalystInfo?.WindowsPCName || 'N/A',
        userName: extra.json.AnalystInfo?.UserName || 'N/A',

        // Parts Replaced
        batteryStatus: partsReplaced.Battery?.result || 'N/A',
        lcdStatus: partsReplaced.LCD?.result || 'N/A',
        mainBoardStatus: partsReplaced.MainBoard?.result || 'N/A',
      };
    } catch (error) {
      console.error(`Failed to fetch report details for ReportID ${reportId}:`, error);
      return null;
    }
  };

  
  /// Export as CSV handler
  
  const allFields = [
    'Report-ID', 'Start-Time', 'Finish-Time', 'IMEI', 'Serial-Number', 'Device-ID', 'Manufacturer', 'Model', 'OS',
    'Operator', 'Report-Status', 'Report-Result', 'Report-Type', 'Action', 'Value', 'Grade', 
    // 'Country-Origin',
    'CPU', 'CPU-Speed', 'RAM', 'Memory-Size', 'Device-Color', 'LCD-Resolution',
    //  'LCD-Size', 'MDM-Status',
    'Manufacture-Date', 'Product-Version', 'Original-Product-Version', 'Software-Build', 'Rooted',

    // 'Battery-Health', 'Battery-Cycle-Count', 'Battery-Grading', 'Battery-Full-Charge-Capacity',
    // 'Battery-Design-Capacity', 'Battery-Serial-Number', 'Battery-Temp', 'Wipe-Method', 'Wipe-Status',


    'Analyst-ID', 'Analyst-App-Version', 'License-ID', 'License-Report-Mode', 'Site-ID',
    'Profile-Name', 'Test-Case-Fails', 'Windows-PC-Name', 'User-Name', 
    // 'Parts-Replaced-Battery',
    // 'Parts-Replaced-LCD', 'Main-Board-Status',
     'ANumber', 'BaseBand-Version', 'Build-Version', 'Cpu-Name', 'Decimal-MEID', 'Device-Enclosure-Color',
    'ECID', 'FMIP', 'Hardware-Model', 'Hardware-Platform', 'Model-Number', 'Region-Info',
    // 'Product-Type',
     'Battery-Manufacturer-Date', 
    // 'Battery-Overall-Percentage', 'Asset-Management',
    'Unique-License-ID', 'Finish-Date', 'Start-Date', 'Result', 'QR-Code-Link', 'Back-Image', 'Behind-Image', 
    'Font_LightAngle1-Image', 'Font_LightAngle2-Image', 'Font_LightAngle3-Image', 
    'Font_LightAngle4-Image', 'Font_LightAngle5-Image', 'Font_LightAngle6-Image', 
    'Font_LightAngle7-Image', 'Font_LightAngle8-Image', 'Front-Image', 'Report-Link',
  ];
  
  const toggleFieldSelection = (field) => {
    setSelectedFields((prev) =>
      prev.includes(field) ? prev.filter((f) => f !== field) : [...prev, field]
    );
  };

  const handleSelectAllFields = () => {
    if (selectAllFields) {
      setSelectedFields([]);
    } else {
      setSelectedFields([...allFields]);
    }
    setSelectAllFields(!selectAllFields);
  };

  const handleExportClick = () => {
    setModalVisible(true);
  };

  const handleUpdateReport = async (reportId, grade, reason, imageLink, videoLink) => {
    try {
      // Construct payload dynamically (include links only if provided)
      const payload = { grade, reason };
      if (imageLink) payload.imageLink = imageLink;
      if (videoLink) payload.videoLink = videoLink;
  
      await axios.put(`/api/report/${reportId}`, payload);
      message.success("Grade, reason, and media links updated successfully");
  
      // Update reports list after updating the report
      setReports((prevReports) =>
        prevReports.map((report) =>
          report.reportId === reportId
            ? { ...report, grade, reason, imageLink, videoLink }
            : report
        )
      );
  
      handleModalClose(); // Close modal after update
    } catch (error) {
      console.error("Error updating report:", error);
      message.error("Failed to update report");
    }
  };

  const exportAsCSV = async () => {
    setModalVisible(false);

    if (selectedFields.length === 0) {
      alert('Please select at least one field to export.');
      return;
    }

    const selectedReports = reports.filter((report) => checkedItems[report.reportId]);
    if (selectedReports.length === 0) {
      alert('Please select at least one record to export.');
      return;
    }

    const csvRows = [selectedFields];

    for (const report of selectedReports) {
      try {
        const response = await axios.get(`/api/report/${report.reportId}`);
        const reportData = response.data;
        const data = reportData.report.data.report || {};
        const deviceInfo = reportData.report.data.extra?.json?.DeviceInfo || {};
        const analystInfo = reportData.report.data.extra?.json?.AnalystInfo || {};
        const batteryInfo = reportData.report.data.extra?.json?.BatteryInfo?.[0] || {};

        const row = selectedFields.map((field) => {
          switch (field) {
            case 'Report-ID': return data.reportid || '';
            case 'Start-Time': return data.starttime || '';
            case 'Finish-Time': return data.finishtime || '';
            case 'IMEI': return data.IMEI || deviceInfo.IMEI || '';
            case 'Serial-Number': return data.serialnumber || deviceInfo.SerialNumber || '';
            case 'Device-ID': return data.deviceid || deviceInfo.DeviceId || '';
            case 'Manufacturer': return data.Manufacturer || deviceInfo.Manufacturer || '';
            case 'Model': return data.Model || deviceInfo.Model || '';
            case 'OS': return data.os || deviceInfo.OperatingSystem || '';
            case 'Operator': return data.operator || '';
            case 'Report-Status': return data.reportstatus || '';
            case 'Report-Result': return data.reportresult || '';
            case 'Report-Type': return data.reporttype || '';
            case 'Action': return data.action || '';
            case 'Value': return data.value || '';
            case 'Grade': return data.grade || '';
        
            // Device Info
            //case 'Country-Origin': return deviceInfo.CountryOrigin || '';
            case 'CPU': return deviceInfo.CPU || '';
            case 'Cpu-Name': return deviceInfo.CpuName || '';
            case 'CPU-Speed': return deviceInfo.CpuSpeed || '';
            case 'RAM': return deviceInfo.RAM || '';
            case 'Memory-Size': return deviceInfo.HandsetMemorySize || '';
            case 'Device-Color': return deviceInfo.DeviceColor || '';
            case 'ANumber': return deviceInfo.ANumber || '';
            case 'BaseBand-Version': return deviceInfo.BaseBandVersion || '';
            case 'Build-Version': return deviceInfo.BuildVersion || '';
            case 'Decimal-MEID': return deviceInfo.DecimalMEID || '';
            case 'Device-Enclosure-Color': return deviceInfo.DeviceEnclosureColor || '';
            case 'ECID': return deviceInfo.ECID || '';
            case 'FMIP': return deviceInfo.FMIP || '';
            case 'Hardware-Model': return deviceInfo.HardwareModel || '';
            case 'Hardware-Platform': return deviceInfo.HardwarePlatform || '';
            case 'Model-Number': return deviceInfo.ModelNumber || '';
            case 'Region-Info': return deviceInfo.RegionInfo || '';
            case 'Product-Type': return deviceInfo.ProductType || '';
            case 'MDM-Status': return deviceInfo.MDMStatus || '';
            case 'Manufacture-Date': return deviceInfo.ManufactureDate || '';
            case 'Product-Version': return deviceInfo.ProductVersion || '';
            case 'Original-Product-Version': return deviceInfo.OriginalProductVersion || '';
            case 'Software-Build': return deviceInfo.SoftwareBuild || '';
            case 'Rooted': return deviceInfo.Rooted || '';
        
            // Battery Info
            case 'Battery-Health': return batteryInfo?.[0]?.BatteryHealth || '';
            case 'Battery-Cycle-Count': return batteryInfo?.[0]?.BatteryCycleCount || '';
            case 'Battery-Grading': return batteryInfo?.[0]?.BatteryGrading || '';
            case 'Battery-Full-Charge-Capacity': return batteryInfo?.[0]?.BatteryFullChargeCapacity || '';
            case 'Battery-Design-Capacity': return batteryInfo?.[0]?.BatteryDesignCapacity || '';
            case 'Battery-Serial-Number': return batteryInfo?.[0]?.BatterySerial || '';
            case 'Battery-Temp': return batteryInfo?.[0]?.BatteryTemp || '';
            case 'Battery-Manufacturer-Date': return batteryInfo?.[0]?.BatteryManufacturerDate || '';
            case 'Battery-Overall-Percentage': return batteryInfo?.[0]?.BatteryOverallPercentage || '';
        
            // Analyst Info
            case 'Analyst-ID': return analystInfo.AnalystId || '';
            case 'Analyst-App-Version': return analystInfo.AnalystApplicationVersion || '';
            case 'License-ID': return analystInfo.LicenseId || '';
            case 'License-Report-Mode': return analystInfo.LicenseReportMode || '';
            case 'Site-ID': return analystInfo.SiteID || '';
            case 'Profile-Name': return analystInfo.ProfileName || '';
            case 'Test-Case-Fails': return analystInfo.TestCaseFails || '';
            case 'Windows-PC-Name': return analystInfo.WindowsPCName || '';
            case 'User-Name': return analystInfo.UserName || '';
            case 'Asset-Management': return analystInfo.AssetManagement || '';
            case 'Finish-Date': return analystInfo.FinishDate || '';
            case 'Start-Date': return analystInfo.StartDate || '';
            case 'Unique-License-ID': return analystInfo.UniqueLicenseId || '';
            case 'Result': return analystInfo.Result || '';
        
            // Links
            case 'QR-Code-Link': return `https://dymax.a2hosted.com/buybackbatch/qrcodes/${data.IMEI}.png`;
            case 'Report-Link': return `https://report.gearvu.io/report/${data.IMEI}`;

             // ✅ Image URLs
            case 'Back-Image':
              return `https://report.gearvu.io/kiosk-image/downloaded_files/${data.IMEI}/Back.jpg`;
            case 'Behind-Image':
              return `https://report.gearvu.io/kiosk-image/downloaded_files/${data.IMEI}/Behind.jpg`;
            case 'Font_LightAngle1-Image':
              return `https://report.gearvu.io/kiosk-image/downloaded_files/${data.IMEI}/Font_LightAngle1.jpg`;
            case 'Font_LightAngle2-Image':
              return `https://report.gearvu.io/kiosk-image/downloaded_files/${data.IMEI}/Font_LightAngle2.jpg`;
            case 'Font_LightAngle3-Image':
              return `https://report.gearvu.io/kiosk-image/downloaded_files/${data.IMEI}/Font_LightAngle3.jpg`;
            case 'Font_LightAngle4-Image':
              return `https://report.gearvu.io/kiosk-image/downloaded_files/${data.IMEI}/Font_LightAngle4.jpg`;
            case 'Font_LightAngle5-Image':
              return `https://report.gearvu.io/kiosk-image/downloaded_files/${data.IMEI}/Font_LightAngle5.jpg`;
            case 'Font_LightAngle6-Image':
              return `https://report.gearvu.io/kiosk-image/downloaded_files/${data.IMEI}/Font_LightAngle6.jpg`;
            case 'Font_LightAngle7-Image':
              return `https://report.gearvu.io/kiosk-image/downloaded_files/${data.IMEI}/Font_LightAngle7.jpg`;
            case 'Font_LightAngle8-Image':
              return `https://report.gearvu.io/kiosk-image/downloaded_files/${data.IMEI}/Font_LightAngle8.jpg`;
            case 'Front-Image':
              return `https://report.gearvu.io/kiosk-image/downloaded_files/${data.IMEI}/Front.jpg`;

        
            default: return '';
          }
        });

        csvRows.push(row);
      } catch (error) {
        console.error(`Error fetching data for Report ID: ${report.reportId}`, error);
      }
    }

    const csvContent = csvRows.map(row => row.join(',')).join('\n');
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.setAttribute('download', 'exported_reports.csv');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  // Export QR codes
  const exportQRCodes = async () => {
    console.log("Starting exportQRCodes function...");
  
    // Filter the selected reports based on checked items
    const selectedReports = reports.filter((report) => checkedItems[report.reportId]);
    console.log(`Selected Reports Count: ${selectedReports.length}`);
  
    if (selectedReports.length === 0) {
      alert("Please select at least one record to export.");
      console.warn("No reports selected for QR code export.");
      return;
    }
  
    const zip = new JSZip();
    const folder = zip.folder("QRCodes");
  
    const promises = selectedReports.map(async (report) => {
      const qrCodeUrl = `https://report.gearvu.io/report/${report.reportId}`;
      console.log(`Generating QR code for Report ID: ${report.reportId}, IMEI: ${report.imei}`);
      console.log(`QR Code URL: ${qrCodeUrl}`);
  
      try {
        const qrCodeDataUrl = await QRCode.toDataURL(qrCodeUrl, { width: 300 });
        console.log(`QR Code generated for IMEI ${report.imei}`);
        
        const blob = await (await fetch(qrCodeDataUrl)).blob();
        console.log(`QR Code blob fetched for IMEI ${report.imei}`);
        
        folder.file(`${report.imei}.png`, blob);
        console.log(`QR Code added to zip for IMEI ${report.imei}`);
      } catch (error) {
        console.error(`Failed to generate QR code for IMEI ${report.imei}:`, error);
      }
    });
  
    await Promise.all(promises);
  
    zip.generateAsync({ type: "blob" }).then((content) => {
      console.log("ZIP file generated successfully.");
      saveAs(content, "QRCodes.zip");
      console.log("ZIP file download initiated.");
    }).catch((error) => {
      console.error("Failed to generate ZIP file:", error);
    });
  
    console.log("exportQRCodes function completed.");
  };

  const openUpdateModal = (report) => {
    console.log(report,'sdfssfd');
    
    setSelectedReport(report);
    setIsModalVisible(true);
  };

  // Function to handle modal close
  const handleModalClose = () => {
    setIsModalVisible(false);
    setSelectedReport(null);
  };
   
  const handleSortChange = (order) => {
    setSortOrder(order);
    setCurrentPage(1);
    setPageCache(new Map()); 
    fetchReports(1, searchQuery, order, dateRange);
  };

    // Function to clear all filters
  const clearFilters = () => {
    setSearchQuery('');
    setDateRange([null, null]);
    setSortOrder('desc');
    setCurrentPage(1);
    setSelectedFilter(null);
    setFilterValue(null);
    setPageCache(new Map()); // Clear cache when filters are cleared
    fetchReports(1, '', null,  [null, null]);

  };

    const handleFilterChange = (value) => {
    debugger
    setFilterValue(value);
    setCurrentPage(1);
    setPageCache(new Map()); // Clear cache when sort changes
    fetchReports(1, searchQuery, value, dateRange);
    // Trigger filtering logic here if needed
  };

  useEffect(() => {
  if (selectedReport) {
    form.setFieldsValue({
      grade: selectedReport.grade ? String(selectedReport.grade) : undefined,
      reason: selectedReport.reason ? String(selectedReport.reason) : undefined,
      imageLink: selectedReport.imageLink ? String(selectedReport.imageLink) : undefined,
      videoLink: selectedReport.videoLink ? String(selectedReport.videoLink) : undefined,
    });
  }
}, [selectedReport, form]);
console.log("Reports:", selectedReport);
  return (
    <>     
      <div className="App">
        <div className="dashboard">
          <div className="container-fluid">
            <div className="row">
              <Sidebar />
              <div className="col-md-10 main" >
                <h1 className="page-heading" style={{marginTop:-20}}>Inventory Reports</h1>
                                              <div style={{ marginBottom: '20px' }}>
                                 <Row gutter={[16, 16]} align="middle" justify="space-between">
                                   
                                   {/* Search */}
                                   <Col xs={24} sm={12} md={8}>
                                     <div className="input-group">
                                       <div className="input-group-prepend">
                                         <span className="input-group-text">
                                           <img src={search} alt="Search" />
                                         </span>
                                       </div>
                                       <input
                                         type="text"
                                         className="form-control"
                                         placeholder="Search IMEI, Re_ID, Brand, Model"
                                         value={searchQuery}
                                         onChange={handleSearchChange}
                                       />
                                     </div>
                                   </Col>
                               
                                   {/* Date Range */}
                                   <Col xs={24} sm={12} md={8}>
                                     <div className="input-group">
                                       <RangePicker
                                         onChange={handleDateRangeChange}
                                         format="YYYY-MM-DD"
                                         placeholder={['Start Date', 'End Date']}
                                         value={dateRange}
                                         style={{ width: '100%' }}
                                       />
                                     </div>
                                   </Col>
                               
                                   {/* Filter + Second Filter */}
                                   {/* <Col xs={24} sm={18} md={5} style={{ display: 'flex', gap: '4px', marginTop:4 }}>
                                     <Select
                                       allowClear
                                       placeholder="Select Filter"
                                       value={selectedFilter}
                                       onChange={(value) => {
                                         
                                         handleFilterChange(value);
                                         setSelectedFilter(value);
                                         setFilterValue(null); // reset dependent value
                                       }}
                                       style={{ flex: 1 }}
                                     >
                                 
                                       <Option value="status">Status</Option>
                                     </Select>
                               
                                     {/* {selectedFilter && (
                                       <Select
                                         placeholder={`Select ${selectedFilter}`}
                                         value={filterValue}
                                         onChange={(value) => {
                                           handleFilterChange(value);
                                           setFilterValue(null);
                                         }}
                                         style={{ flex: 1 }}
                                         options={
                                           filterOptions[selectedFilter]?.map((option) => ({
                                             label: option,
                                             value: option
                                           })) || []
                                         }
                                       />
                                     )}
                                   </Col> */}
                               
                                   {/* Clear Filters */}
                                   {/* <Col xs="auto" style={{marginTop:4}}>
                                     <Button
                                       onClick={clearFilters}
                                       style={{
                                         fontWeight: 'bold',
                                         whiteSpace: 'nowrap'
                                       }}
                                     >
                                       Clear Filters
                                     </Button>
                                   </Col> */}
                               
                                 </Row>
                </div>

             

                <section className="reports" >
                  <div className="container">
                    <div className="row align-items-center">
                      <div className="col-12">
                        <div className="table-responsive">
                        <Spin spinning={loading || isGhlLoading} size="large" wrapperClassName="custom-spin">
                          <table className="table table-striped table-bordered align-items-center">
                            <thead>
                              <tr>
                                <th>
                                  <Checkbox  onChange={handleSelectAll} checked={selectAll} className='custom-checkbox'/>
                                  <span style={{ marginLeft: 8 }}>Select</span>
                                </th>
                                <th>ID</th>
                                <th>SKU</th>
                              <th>
                                  Date/Time
                                  {sortOrder === 'desc' ?
                                    <SortDescendingOutlined style={{ marginLeft: 8, color: '#1890ff' }} /> :
                                    <SortAscendingOutlined style={{ marginLeft: 8, color: '#1890ff' }} />
                                  }
                                </th>
                                <th>IMEI</th>
                                <th>Brand</th>
                                <th>Model</th>
                                <th>Grade</th>
                                {/* <th>Value ($)</th> */}
                                <th>In Stock</th>
                                {/* <th>Status</th> */}
                                <th>Evaluate</th>  
                                <th>Details</th>
                                <th>Report 2.0</th>
                              </tr>
                            </thead>
                            <tbody>
                              {reports.length > 0 ? (
                                reports.map((report) => {
                                  console.log("Report:", report);
                                let found = publishedReports?.find((rep)=>report?.imei===rep?.imei)
                                  
                              return  <tr key={report.reportId}>
                                       <td >
                                       <Checkbox
                                         checked={checkedItems[report.reportId]}
                                         onChange={() => handleCheckboxChange(report.reportId)}
                                         className="custom-checkbox"
                                       />
                                     </td>
                                    <td>{report.reportId}</td>
                                 <td style={{ maxWidth: 240, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
  <Tooltip title={report.sku}>
    {report.sku}
  </Tooltip>
</td>
                                    <td>{report.reportDate}</td>
                                    <td>{report.imei}</td>
                                    <td>{report.brand}</td>
                                    <td>{report.model}</td>
                                    <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                                        {report.grade}
                                        {report.grade && (
                                          <EditOutlined            
                                            style={{ marginLeft: 8, color: '#1890ff', cursor: 'pointer' }}
                                            onClick={()=>openUpdateModal(report)}
                                          />
                                        )}
                                      </td>

                                   <td>{report?.inStock ? report.inStock : 'YES'}</td>
                                    {/* <td>{report.value}$</td> */}
                                    {/* <td>{report.status}</td> */}
                                    <td>  
                                <button
                                     className="btn btn-primary gr"                                     
                                     onClick={() => openUpdateModal(report)}
                                     disabled={report.grade}
                                     style={{
                                       backgroundColor: report.grade ? '#ccc' : '#007bff',
                                       cursor: report.grade ? 'not-allowed' : 'pointer',
                                     }}
                                   >
                                   
                                     {report.grade ? 'Graded' : 'Grade'}
                                   </button>
                                 </td>

                                  <td>
                                    <AntdTooltip title="View Report">
                                    <Button
                                    className="btn btn-primary gr"
                                    onClick={() => openReportDetails(report.imei)}
                                    icon={<EyeOutlined />} 
                                  >                                
                                  </Button> 
                                  </AntdTooltip>

                                      {/* <Button
                                        // loading={isGhlLoading}
                                        disabled={found?true:false}
                                        className="btn btn-primary"
                                        onClick={() => handleCreateReports(report)}
                                      >
                                        {found?'Report Published':'Publish Reports'}
                                      </Button> */}
                                    </td>
                                    {
                                    role === 'admin' && 
                                       <td>       
                                            <Button
                                              style={{ width: '100%' }}
                                              className="simple-btn"

                                            >
                                              <a
                                                // href={`file:///C:/Users/ABC/Downloads/Archive/index.html?imei=${report.uniqueId}`}
                                                href={`https://report.gearvu.io/report/?tier=WAREHOUSE&imei=${report.imei}`}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                              >
                                                2.0
                                              </a>
                                            </Button>
                                          </td>
                                }
                                  </tr>
                                }
                              )
                              ) : (
                                <tr>
                                  <td colSpan="9" style={{ textAlign: 'center', padding: '20px' }}>
                                    <Empty description="Oops! No reports found!" />
                                  </td>
                                </tr>

                              )}
                            </tbody>
                          </table>

                        </Spin>
                         </div>

                         
                        <div className='table-bottom'>
                          <div className='pagination-container'>

                           <Pagination
                              current={currentPage}
                              total={totalReports}
                              pageSize={reportsPerPage}
                              onChange={handlePageChange}
                              showSizeChanger={false}
                              showTotal={(total, range) => {
                                  if (window.innerWidth < 600) {
                                    // On small screens, just show "X-Y"
                                    return `${range[0]}-${range[1]}`;
                                  }
                                  // On larger screens, show full text
                                  return `${range[0]}-${range[1]} of ${total} reports`;
                                }}
                              />
                          
                           </div>
                          <div className='export-buttons'>
                          <button className="black" onClick={exportQRCodes}>Download QR Codes</button>
                         <button className="black" onClick={handleExportClick}>Export as CSV</button>

                        
                         </div>
                      <Modal
                          title="Select Fields to Export"
                          visible={modalVisible}
                          onOk={exportAsCSV}
                          onCancel={() => setModalVisible(false)}
                          width={600}
                        >
                          <div style={{ maxHeight: "400px", overflowY: "auto", padding: "10px" }}>
                            <Checkbox onChange={handleSelectAllFields} checked={selectAllFields} style={{ fontWeight: "bold" }}>
                              Select All
                            </Checkbox>

                            <Divider />

                            <Row gutter={[16, 16]}>
                              {allFields.map((field, index) => (
                                <Col span={12} key={index}>
                                  <Checkbox
                                    checked={selectedFields.includes(field)}
                                    onChange={() => toggleFieldSelection(field)}
                                    style={{ display: "flex", alignItems: "center", padding: "5px 0" }}
                                  >
                                    {field}
                                  </Checkbox>
                                </Col>
                              ))}
                            </Row>
                          </div>
                        </Modal>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            </div>
          </div>
        </div>

        {/* <div>
          <Modal
            title="Evaluate Report"
            visible={isModalVisible}
            onCancel={() => {
              form.resetFields(); 
              handleModalClose();
            }}
            footer={null}
            className="evaluate-report-modal"
          >
            <Form
              form={form}
              layout="vertical"
              onFinish={(values) => {
                
                handleUpdateReport(
                  selectedReport?.reportId,
                  values.grade,
                  values.reason,
                  values.imageLink,
                  values.videoLink
                );
                form.resetFields();      
                handleModalClose();    
              }}
              initialValues={{
                grade: selectedReport?.grade ? String(selectedReport.grade) : undefined,
                reason: selectedReport?.reason ? String(selectedReport.reason) : undefined,
                imageLink: selectedReport?.imageLink ? String(selectedReport.imageLink) : undefined,
                videoLink: selectedReport?.videoLink ? String(selectedReport.videoLink) : undefined,
              }}
            >
              <Form.Item
                label="Grade"
                name="grade"
                rules={[{ required: true, message: "Please select a grade!" }]}
                >
                <Select 
                 allowClear
                
                placeholder="Select grade">
                  <Select.Option value="1">1 (newPrice)</Select.Option>
                  <Select.Option value="2">2 (goodPrice)</Select.Option>
                  <Select.Option value="3">3 (badPrice)</Select.Option>
                  <Select.Option value="4">4 (recyclePrice)</Select.Option>
                </Select>
              </Form.Item>

              <Form.Item
                label="Reason"
                name="reason"
                rules={[{ required: true, message: "Please provide a reason!" }]}
              >
                <Input.TextArea placeholder="Enter reason for grade change" />
              </Form.Item>

              <Form.Item
                label="Image Link (Optional)"
                name="imageLink"
                rules={[
                  {
                    type: "url",
                    message: "Please enter a valid URL!",
                  },
                  {
                    message: "Please enter a valid image URL!",
                  },
                ]}
              >
                <Input.TextArea placeholder="Enter image link (if any)" />
              </Form.Item>

              <Form.Item
                label="Video Link (Optional)"
                name="videoLink"
                rules={[
                  {
                    type: "url",
                    message: "Please enter a valid URL!",
                  },
                  {
                   
                    message: "Please enter a valid video URL!",
                  },
                ]}
              >
                <Input.TextArea placeholder="Enter video link (if any)" />
              </Form.Item>

              <Form.Item>
                <button className="btn btn-primary" type="submit">
                  Save
                </button>
              </Form.Item>
            </Form>
          </Modal>
      </div> */}
      import { useEffect } from "react";

<div>
  <Modal
    title="Evaluate Report"
    visible={isModalVisible}
    onCancel={() => {
      form.resetFields();
      handleModalClose();
    }}
    footer={null}
    className="evaluate-report-modal"
  >
    <Form
      form={form}
      layout="vertical"
      onFinish={(values) => {
        handleUpdateReport(
          selectedReport?.reportId,
          values.grade || "",       // send empty string if cleared
          values.reason || "",
          values.imageLink || "",
          values.videoLink || ""
        );
        form.resetFields();
        handleModalClose();
      }}
      initialValues={{
        grade: selectedReport?.grade ? String(selectedReport.grade) : undefined,
        reason: selectedReport?.reason || undefined,
        imageLink: selectedReport?.imageLink || undefined,
        videoLink: selectedReport?.videoLink || undefined,
      }}
    >
      <Form.Item
        label="Grade"
        name="grade"
        rules={[{ required: true, message: "Please select a grade!" }]}
      >
        <Select allowClear placeholder="Select grade">
          <Select.Option value="1">1 (newPrice)</Select.Option>
          <Select.Option value="2">2 (goodPrice)</Select.Option>
          <Select.Option value="3">3 (badPrice)</Select.Option>
          <Select.Option value="4">4 (recyclePrice)</Select.Option>
        </Select>
      </Form.Item>

      <Form.Item
        label="Reason"
        name="reason"
        rules={[{ required: true, message: "Please provide a reason!" }]}
      >
        <Input.TextArea placeholder="Enter reason for grade change" allowClear />
      </Form.Item>

      <Form.Item
        label="Image Link (Optional)"
        name="imageLink"
        rules={[
          {
            type: "url",
            message: "Please enter a valid URL!",
          },
        ]}
      >
        <Input.TextArea placeholder="Enter image link (if any)" allowClear />
      </Form.Item>

      <Form.Item
        label="Video Link (Optional)"
        name="videoLink"
        rules={[
          {
            type: "url",
            message: "Please enter a valid URL!",
          },
        ]}
      >
        <Input.TextArea placeholder="Enter video link (if any)" allowClear />
      </Form.Item>

      <Form.Item>
        <button className="btn btn-primary" type="submit">
          Save
        </button>
      </Form.Item>
    </Form>
  </Modal>
</div>

      </div>
    </>
  );
}

export default DeviceReports;

// import Sidebar from '../Sidebar/Sidebar';
// import './DeviceReports.css'

// import { useNavigate } from 'react-router-dom';
// import { FloatButton, Checkbox, Spin, Pagination, Empty, Modal, Input, Form, Button, message, Popconfirm, Row, Col, Divider, DatePicker, Tooltip as AntdTooltip, Select } from 'antd';
// import { FilePdfOutlined, FileExcelOutlined, ExportOutlined, EyeOutlined } from '@ant-design/icons';
// import { useState, useEffect } from 'react';
// import jsPDF from 'jspdf';
// // import axios from 'axios';
// // QR codes ZIP
// import QRCode from "qrcode";
// import JSZip from "jszip";
// import { saveAs } from "file-saver";
// import search from '../Dashboard/assets/img/search.png';
// import SignInToHighLevel from '../../gohighlevel/SignInToHighLevel';
// import axiosApi from '../../axiosApi/axiosApi';
// import axios from 'axios';
// const { RangePicker } = DatePicker;

// function DeviceReports() {
//   const navigate = useNavigate();
//   const [reports, setReports] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [checkedItems, setCheckedItems] = useState({});
//   const [searchQuery, setSearchQuery] = useState('');
//   const [filteredReports, setFilteredReports] = useState([]);
//   const [dateRange, setDateRange] = useState([null, null]);
//   const [selectAll, setSelectAll] = useState(false);
//   const [isGolevelSignedIn, setIsGolevelSignedIn] = useState(false);
//   const [modalOpen, setModalOpen] = useState(false);
//   const [modalVisible, setModalVisible] = useState(false);
//   const [selectedFields, setSelectedFields] = useState([]);
//   const [selectAllFields, setSelectAllFields] = useState(false);
//   // States for Pagination
//   const [currentPage, setCurrentPage] = useState(1);
//   const [isGhlLoading, setIsGhlLoading] = useState(false);
//   const [publishedReports, setPublishedReports] = useState([]);
//   const reportsPerPage = 12;
  
//   // State for modal visibility and selected report
//   const [isModalVisible, setIsModalVisible] = useState(false);
//   const [selectedReport, setSelectedReport] = useState(null);
//   const [totalReports, setTotalReports] = useState(0);
//   const [pageCache, setPageCache] = useState(new Map());

//   const [form] = Form.useForm();
 

//   // Function to open report details in a new tab
//   function openReportDetails(reportId) {
//     window.open(`/report/${reportId}`, '_blank');
//   }

//   // Create cache key for current filters
//     const getCacheKey = useCallback(() => {
//       return `${currentPage}-${reportsPerPage}-${searchQuery}-${sortOrder}-${dateRange[0]?.format('YYYY-MM-DD') || ''}-${dateRange[1]?.format('YYYY-MM-DD') || ''}`;
//     }, [currentPage, reportsPerPage, searchQuery, sortOrder, dateRange]);
  
  
//     // Fetch reports from the API
// const fetchReports = async (page = currentPage, search = searchQuery, sort = sortOrder, dateFilter = dateRange) => {
//       setLoading(true);
    
//       try {
//          // Check cache first
//               const cacheKey = `${page}-${reportsPerPage}-${search}-${sort}-${dateFilter[0]?.format('YYYY-MM-DD') || ''}-${dateFilter[1]?.format('YYYY-MM-DD') || ''}`;
        
//               if (pageCache.has(cacheKey)) {
//                 const cachedData = pageCache.get(cacheKey);
//                 setReports(cachedData.reports);
//                 setTotalReports(cachedData.totalReports);
//                 setLoading(false);
//                 return;
//               }
        
//               const params = {
//                 page,
//                 limit: reportsPerPage,
//                 sortOrder: sort,
//               };
        
//               // Add search query if present
//               if (search && search.trim()) {
//                 params.search = search.trim();
//               }
        
//               // Add date range if present
//               if (dateFilter[0] && dateFilter[1]) {
//                 params.startDate = dateFilter[0].format('YYYY-MM-DD');
//                 params.endDate = dateFilter[1].format('YYYY-MM-DD');
//               }
        
        
//         const response = await axios.get('/api/reports/dashboard', {[params]});
  
//         // Process reports data
//         const fetchedReports = response.data.reports.map((report) => ({
//           reportId: report.data.report.reportid,
//           reportDate: report.data.report.finishtime,
//           imei: report.data.report.IMEI,
//           brand: report.data.report.Manufacturer,
//           model: report.data.report.Model,
//           value: report.data.report.value,
//           grade: report.data.report.grade,
//           sku: report.data.report.sku,
//           status: report.data.report.reportstatus,
//           inStock: report.data.report.inStock,
//         }));
  
//         setReports(fetchedReports);
//          setTotalReports(response.data.totalReports);
         
//              setPageCache(prev => {
//         const newCache = new Map(prev);
//         newCache.set(cacheKey, {
//           reports: fetchedReports,
//           totalReports: response.data.totalReports
//         });

//         // Limit cache size to prevent memory issues (keep last 20 pages)
//         if (newCache.size > 20) {
//           const firstKey = newCache.keys().next().value;
//           newCache.delete(firstKey);
//         }

//         return newCache;
//       });

//         // Initialize checkbox state
//         const initialCheckedState = fetchedReports.reduce((acc, report) => {
//           acc[report.reportId] = false;
//           return acc;
//         }, {});
//         setCheckedItems(initialCheckedState);
  
//         setLoading(false);
//       } catch (error) {
//         console.error('Error fetching reports:', error);
//         setLoading(false);
//          message.error('Failed to fetch reports');
//       }
//     };
//   useEffect(() => {
//      fetchReports();
//   }, []);
  

//   // Handle search with debounce
//   const handleSearchChange = (e) => {
//     const value = e.target.value;
//     setSearchQuery(value);

//     // Clear existing timeout
//     if (searchTimeout) {
//       clearTimeout(searchTimeout);
//     }

//     // Set new timeout for debounced search
//     const newTimeout = setTimeout(() => {
//       setCurrentPage(1); // Reset to first page
//       setPageCache(new Map()); // Clear cache when search changes
//       fetchReports(1, value, sortOrder, dateRange);
//     }, 500); // 500ms debounce

//     setSearchTimeout(newTimeout);
//   };

//   // Handle page change
//   const handlePageChange = (page) => {
//     setCurrentPage(page);
//     fetchReports(page, searchQuery, sortOrder, dateRange);
//   };

//   // Handle sort order change
//   const handleSortChange = (order) => {
//     setSortOrder(order);
//     setCurrentPage(1);
//     setPageCache(new Map()); // Clear cache when sort changes
//     fetchReports(1, searchQuery, order, dateRange);
//   };

//   // Handle date range change
//   const handleDateRangeChange = (dates) => {
//     setDateRange(dates || [null, null]);
//     setCurrentPage(1);
//     setPageCache(new Map()); // Clear cache when date range changes
//     fetchReports(1, searchQuery, sortOrder, dates || [null, null]);
//   };

//   // Function to clear all filters
//   const clearFilters = () => {
//     setSearchQuery('');
//     setDateRange([null, null]);
//     setSortOrder('desc');
//     setCurrentPage(1);
//     setPageCache(new Map()); // Clear cache when filters are cleared
//     fetchReports(1, '', 'desc', [null, null]);
//   };
  

//   const handleCheckboxChange = (reportId) => {
//     setCheckedItems((prevState) => ({
//       ...prevState,
//       [reportId]: !prevState[reportId],
//     }));
//   };

//   // Filter reports based on search query and date range
//   useEffect(() => {
//     let filtered = reports.filter(
//       (report) =>
//         report.reportId.toString().includes(searchQuery) ||
//         report.imei.toString().includes(searchQuery)
//     );

//     if (dateRange[0] && dateRange[1]) {
//       filtered = filtered.filter((report) => {
//         const reportDate = new Date(report.reportDate);
//         return (
//           reportDate >= dateRange[0].startOf('day').toDate() &&
//           reportDate <= dateRange[1].endOf('day').toDate()
//         );
//       });
//     }

//     setFilteredReports(filtered);
//   }, [searchQuery, dateRange, reports]);

//   const currentReports = filteredReports.slice(
//     (currentPage - 1) * reportsPerPage,
//     currentPage * reportsPerPage
//   );

//   // Function to fetch and format report details by IMEI
//   const fetchReportDetails = async (reportId) => {
//     try {
//       const response = await axiosApi.get(`/report/${reportId}`);
//       const { report, extra } = response.data.data;
      

//       // Extracting deeply nested values safely
//       const partsReplaced = extra.json.PartsReplaced?.iOS || {};
//       const batteryInfo = extra.json.DeviceInfo?.BatteryInfo[0] || {};

//       return {
//         reportId: report.reportid,
//         startTime: report.starttime,
//         finishTime: report.finishtime,
//         imei: report.IMEI,
//         serialNumber: report.serialnumber,
//         deviceId: report.deviceid || 'N/A',
//         manufacturer: report.Manufacturer,
//         model: report.Model,
//         os: report.os,
//         operator: report.operator,
//         reportStatus: report.reportstatus,
//         reportResult: report.reportresult,
//         reportType: report.reporttype,
//         action: report.action,
//         value: report.value || 'N/A',
//         grade: report.grade || 'N/A',
//         inStock:report.inStock || 'YES',

//         // Device Info
//         countryOrigin: extra.json.DeviceInfo?.CountryOrigin || 'N/A',
//         cpu: extra.json.DeviceInfo?.CpuName || 'N/A',
//         cpuSpeed: extra.json.DeviceInfo?.CpuSpeed || 'N/A',
//         ram: extra.json.DeviceInfo?.RAM || 'N/A',
//         memorySize: extra.json.DeviceInfo?.HandsetMemorySize || 'N/A',
//         deviceColor: extra.json.DeviceInfo?.DeviceColor || 'N/A',
//         lcdResolution: extra.json.DeviceInfo?.LCDResolution || 'N/A',
//         lcdSize: extra.json.DeviceInfo?.LCDSize || 'N/A',
//         mdmStatus: extra.json.DeviceInfo?.MDMStatus || 'N/A',
//         manufactureDate: extra.json.DeviceInfo?.ManufactureDate || 'N/A',
//         productVersion: extra.json.DeviceInfo?.ProductVersion || 'N/A',
//         originalProductVersion: extra.json.DeviceInfo?.OriginalProductVersion || 'N/A',
//         softwareBuild: extra.json.DeviceInfo?.SoftwareBuild || 'N/A',
//         rooted: extra.json.DeviceInfo?.Rooted || 'N/A',

//         // Battery Info
//         batteryHealth: batteryInfo.BatteryHealth || 'N/A',
//         batteryCycleCount: batteryInfo.BatteryCycleCount || 'N/A',
//         batteryGrading: batteryInfo.BatteryGrading || 'N/A',
//         batteryFullChargeCapacity: batteryInfo.BatteryFullChargeCapacity || 'N/A',
//         batteryDesignCapacity: batteryInfo.BatteryDesignCapacity || 'N/A',
//         batterySerial: batteryInfo.BatterySerial || 'N/A',
//         batteryTemp: batteryInfo.BatteryTemp || 'N/A',

//         // Wipe Info
//         wipeMethod: extra.json.DataWipeInfo?.WipeMethod || 'N/A',
//         wipeStatus: extra.json.DataWipeInfo?.Status || 'N/A',

//         // Analyst Info
//         analystId: extra.json.AnalystInfo?.AnalystId || 'N/A',
//         analystAppVersion: extra.json.AnalystInfo?.AnalystApplicationVersion || 'N/A',
//         licenseId: extra.json.AnalystInfo?.LicenseId || 'N/A',
//         licenseReportMode: extra.json.AnalystInfo?.LicenseReportMode || 'N/A',
//         siteId: extra.json.AnalystInfo?.SiteID || 'N/A',
//         profileName: extra.json.AnalystInfo?.ProfileName || 'N/A',
//         testCaseFails: extra.json.AnalystInfo?.TestCaseFails || 'N/A',
//         windowsPCName: extra.json.AnalystInfo?.WindowsPCName || 'N/A',
//         userName: extra.json.AnalystInfo?.UserName || 'N/A',

//         // Parts Replaced
//         batteryStatus: partsReplaced.Battery?.result || 'N/A',
//         lcdStatus: partsReplaced.LCD?.result || 'N/A',
//         mainBoardStatus: partsReplaced.MainBoard?.result || 'N/A',
//       };
//     } catch (error) {
//       console.error(`Failed to fetch report details for ReportID ${reportId}:`, error);
//       return null;
//     }
//   };

//   // Handle "Select All" for the current page
//   const handleSelectAll = () => {
//     const newCheckedItems = { ...checkedItems };
//     if (selectAll) {
//       // Unselect all reports on the current page
//       currentReports.forEach((report) => {
//         delete newCheckedItems[report.reportId];
//       });
//     } else {
//       // Select all reports on the current page
//       currentReports.forEach((report) => {
//         newCheckedItems[report.reportId] = true;
//       });
//     }
//     setCheckedItems(newCheckedItems);
//     setSelectAll(!selectAll);
//   };

//   // Pagination
//   const indexOfLastReport = currentPage * reportsPerPage;
//   const indexOfFirstReport = indexOfLastReport - reportsPerPage;



//   // Export as PDF handler
//   // const exportAsPDF = async () => {
//   //   const selectedReports = reports.filter((report) => checkedItems[report.reportId]);
//   //   if (selectedReports.length === 0) {
//   //     alert('Please select at least one record to export.');
//   //     return;
//   //   }

//   //   const doc = new jsPDF();
//   //   doc.text('Trade-in Device Detailed Reports', 10, 10);
//   //   let yPos = 20;

//   //   for (const report of selectedReports) {
//   //     const reportData = await fetchReportDetails(report.imei);
//   //     if (reportData) {
//   //       yPos += 10;
//   //       doc.text(`Report ID: ${reportData.reportId}`, 10, yPos);
//   //       doc.text(`IMEI: ${reportData.imei}`, 10, yPos + 10);
//   //       doc.text(`Model: ${reportData.model}`, 10, yPos + 20);
//   //       doc.text(`Manufacturer: ${reportData.manufacturer}`, 10, yPos + 30);
//   //       doc.text(`OS: ${reportData.os}`, 10, yPos + 40);
//   //       doc.text(`Report Result: ${reportData.reportResult}`, 10, yPos + 50);
//   //       doc.text(`Battery Health: ${reportData.batteryHealth}`, 10, yPos + 60);
//   //       doc.text(`RAM: ${reportData.ram}`, 10, yPos + 70);
//   //       doc.text(`Wipe Method: ${reportData.wipeMethod}`, 10, yPos + 80);
//   //       doc.text(`LCD Status: ${reportData.lcdStatus}`, 10, yPos + 90);
//   //       yPos += 100;
//   //     }
//   //   }

//   //   doc.save('detailed-reports.pdf');
//   // };

//   /// Export as CSV handler
  
//   const allFields = [
//     'Report-ID', 'Start-Time', 'Finish-Time', 'IMEI', 'Serial-Number', 'Device-ID', 'Manufacturer', 'Model', 'OS',
//     'Operator', 'Report-Status', 'Report-Result', 'Report-Type', 'Action', 'Value', 'Grade', 
//     // 'Country-Origin',
//     'CPU', 'CPU-Speed', 'RAM', 'Memory-Size', 'Device-Color', 'LCD-Resolution',
//     //  'LCD-Size', 'MDM-Status',
//     'Manufacture-Date', 'Product-Version', 'Original-Product-Version', 'Software-Build', 'Rooted',

//     // 'Battery-Health', 'Battery-Cycle-Count', 'Battery-Grading', 'Battery-Full-Charge-Capacity',
//     // 'Battery-Design-Capacity', 'Battery-Serial-Number', 'Battery-Temp', 'Wipe-Method', 'Wipe-Status',


//     'Analyst-ID', 'Analyst-App-Version', 'License-ID', 'License-Report-Mode', 'Site-ID',
//     'Profile-Name', 'Test-Case-Fails', 'Windows-PC-Name', 'User-Name', 
//     // 'Parts-Replaced-Battery',
//     // 'Parts-Replaced-LCD', 'Main-Board-Status',
//      'ANumber', 'BaseBand-Version', 'Build-Version', 'Cpu-Name', 'Decimal-MEID', 'Device-Enclosure-Color',
//     'ECID', 'FMIP', 'Hardware-Model', 'Hardware-Platform', 'Model-Number', 'Region-Info',
//     // 'Product-Type',
//      'Battery-Manufacturer-Date', 
//     // 'Battery-Overall-Percentage', 'Asset-Management',
//     'Unique-License-ID', 'Finish-Date', 'Start-Date', 'Result', 'QR-Code-Link', 'Back-Image', 'Behind-Image', 
//     'Font_LightAngle1-Image', 'Font_LightAngle2-Image', 'Font_LightAngle3-Image', 
//     'Font_LightAngle4-Image', 'Font_LightAngle5-Image', 'Font_LightAngle6-Image', 
//     'Font_LightAngle7-Image', 'Font_LightAngle8-Image', 'Front-Image', 'Report-Link',
//   ];
  
//   const toggleFieldSelection = (field) => {
//     setSelectedFields((prev) =>
//       prev.includes(field) ? prev.filter((f) => f !== field) : [...prev, field]
//     );
//   };

//   const handleSelectAllFields = () => {
//     if (selectAllFields) {
//       setSelectedFields([]);
//     } else {
//       setSelectedFields([...allFields]);
//     }
//     setSelectAllFields(!selectAllFields);
//   };

//   const handleExportClick = () => {
//     setModalVisible(true);
//   };

//   const handleUpdateReport = async (reportId, grade, reason, imageLink, videoLink) => {
//     try {
//       // Construct payload dynamically (include links only if provided)
//       const payload = { grade, reason };
//       if (imageLink) payload.imageLink = imageLink;
//       if (videoLink) payload.videoLink = videoLink;
  
//       await axios.put(`/api/report/${reportId}`, payload);
//       message.success("Grade, reason, and media links updated successfully");
  
//       // Update reports list after updating the report
//       setReports((prevReports) =>
//         prevReports.map((report) =>
//           report.reportId === reportId
//             ? { ...report, grade, reason, imageLink, videoLink }
//             : report
//         )
//       );
  
//       handleModalClose(); // Close modal after update
//     } catch (error) {
//       console.error("Error updating report:", error);
//       message.error("Failed to update report");
//     }
//   };

//   const exportAsCSV = async () => {
//     setModalVisible(false);

//     if (selectedFields.length === 0) {
//       alert('Please select at least one field to export.');
//       return;
//     }

//     const selectedReports = reports.filter((report) => checkedItems[report.reportId]);
//     if (selectedReports.length === 0) {
//       alert('Please select at least one record to export.');
//       return;
//     }

//     const csvRows = [selectedFields];

//     for (const report of selectedReports) {
//       try {
//         const response = await axios.get(`/api/report/${report.reportId}`);
//         const reportData = response.data;
//         const data = reportData.report.data.report || {};
//         const deviceInfo = reportData.report.data.extra?.json?.DeviceInfo || {};
//         const analystInfo = reportData.report.data.extra?.json?.AnalystInfo || {};
//         const batteryInfo = reportData.report.data.extra?.json?.BatteryInfo?.[0] || {};

//         const row = selectedFields.map((field) => {
//           switch (field) {
//             case 'Report-ID': return data.reportid || '';
//             case 'Start-Time': return data.starttime || '';
//             case 'Finish-Time': return data.finishtime || '';
//             case 'IMEI': return data.IMEI || deviceInfo.IMEI || '';
//             case 'Serial-Number': return data.serialnumber || deviceInfo.SerialNumber || '';
//             case 'Device-ID': return data.deviceid || deviceInfo.DeviceId || '';
//             case 'Manufacturer': return data.Manufacturer || deviceInfo.Manufacturer || '';
//             case 'Model': return data.Model || deviceInfo.Model || '';
//             case 'OS': return data.os || deviceInfo.OperatingSystem || '';
//             case 'Operator': return data.operator || '';
//             case 'Report-Status': return data.reportstatus || '';
//             case 'Report-Result': return data.reportresult || '';
//             case 'Report-Type': return data.reporttype || '';
//             case 'Action': return data.action || '';
//             case 'Value': return data.value || '';
//             case 'Grade': return data.grade || '';
        
//             // Device Info
//             //case 'Country-Origin': return deviceInfo.CountryOrigin || '';
//             case 'CPU': return deviceInfo.CPU || '';
//             case 'Cpu-Name': return deviceInfo.CpuName || '';
//             case 'CPU-Speed': return deviceInfo.CpuSpeed || '';
//             case 'RAM': return deviceInfo.RAM || '';
//             case 'Memory-Size': return deviceInfo.HandsetMemorySize || '';
//             case 'Device-Color': return deviceInfo.DeviceColor || '';
//             case 'ANumber': return deviceInfo.ANumber || '';
//             case 'BaseBand-Version': return deviceInfo.BaseBandVersion || '';
//             case 'Build-Version': return deviceInfo.BuildVersion || '';
//             case 'Decimal-MEID': return deviceInfo.DecimalMEID || '';
//             case 'Device-Enclosure-Color': return deviceInfo.DeviceEnclosureColor || '';
//             case 'ECID': return deviceInfo.ECID || '';
//             case 'FMIP': return deviceInfo.FMIP || '';
//             case 'Hardware-Model': return deviceInfo.HardwareModel || '';
//             case 'Hardware-Platform': return deviceInfo.HardwarePlatform || '';
//             case 'Model-Number': return deviceInfo.ModelNumber || '';
//             case 'Region-Info': return deviceInfo.RegionInfo || '';
//             case 'Product-Type': return deviceInfo.ProductType || '';
//             case 'MDM-Status': return deviceInfo.MDMStatus || '';
//             case 'Manufacture-Date': return deviceInfo.ManufactureDate || '';
//             case 'Product-Version': return deviceInfo.ProductVersion || '';
//             case 'Original-Product-Version': return deviceInfo.OriginalProductVersion || '';
//             case 'Software-Build': return deviceInfo.SoftwareBuild || '';
//             case 'Rooted': return deviceInfo.Rooted || '';
        
//             // Battery Info
//             case 'Battery-Health': return batteryInfo?.[0]?.BatteryHealth || '';
//             case 'Battery-Cycle-Count': return batteryInfo?.[0]?.BatteryCycleCount || '';
//             case 'Battery-Grading': return batteryInfo?.[0]?.BatteryGrading || '';
//             case 'Battery-Full-Charge-Capacity': return batteryInfo?.[0]?.BatteryFullChargeCapacity || '';
//             case 'Battery-Design-Capacity': return batteryInfo?.[0]?.BatteryDesignCapacity || '';
//             case 'Battery-Serial-Number': return batteryInfo?.[0]?.BatterySerial || '';
//             case 'Battery-Temp': return batteryInfo?.[0]?.BatteryTemp || '';
//             case 'Battery-Manufacturer-Date': return batteryInfo?.[0]?.BatteryManufacturerDate || '';
//             case 'Battery-Overall-Percentage': return batteryInfo?.[0]?.BatteryOverallPercentage || '';
        
//             // Analyst Info
//             case 'Analyst-ID': return analystInfo.AnalystId || '';
//             case 'Analyst-App-Version': return analystInfo.AnalystApplicationVersion || '';
//             case 'License-ID': return analystInfo.LicenseId || '';
//             case 'License-Report-Mode': return analystInfo.LicenseReportMode || '';
//             case 'Site-ID': return analystInfo.SiteID || '';
//             case 'Profile-Name': return analystInfo.ProfileName || '';
//             case 'Test-Case-Fails': return analystInfo.TestCaseFails || '';
//             case 'Windows-PC-Name': return analystInfo.WindowsPCName || '';
//             case 'User-Name': return analystInfo.UserName || '';
//             case 'Asset-Management': return analystInfo.AssetManagement || '';
//             case 'Finish-Date': return analystInfo.FinishDate || '';
//             case 'Start-Date': return analystInfo.StartDate || '';
//             case 'Unique-License-ID': return analystInfo.UniqueLicenseId || '';
//             case 'Result': return analystInfo.Result || '';
        
//             // Links
//             case 'QR-Code-Link': return `https://dymax.a2hosted.com/buybackbatch/qrcodes/${data.IMEI}.png`;
//             case 'Report-Link': return `https://report.gearvu.io/report/${data.IMEI}`;

//              // ✅ Image URLs
//             case 'Back-Image':
//               return `https://report.gearvu.io/kiosk-image/downloaded_files/${data.IMEI}/Back.jpg`;
//             case 'Behind-Image':
//               return `https://report.gearvu.io/kiosk-image/downloaded_files/${data.IMEI}/Behind.jpg`;
//             case 'Font_LightAngle1-Image':
//               return `https://report.gearvu.io/kiosk-image/downloaded_files/${data.IMEI}/Font_LightAngle1.jpg`;
//             case 'Font_LightAngle2-Image':
//               return `https://report.gearvu.io/kiosk-image/downloaded_files/${data.IMEI}/Font_LightAngle2.jpg`;
//             case 'Font_LightAngle3-Image':
//               return `https://report.gearvu.io/kiosk-image/downloaded_files/${data.IMEI}/Font_LightAngle3.jpg`;
//             case 'Font_LightAngle4-Image':
//               return `https://report.gearvu.io/kiosk-image/downloaded_files/${data.IMEI}/Font_LightAngle4.jpg`;
//             case 'Font_LightAngle5-Image':
//               return `https://report.gearvu.io/kiosk-image/downloaded_files/${data.IMEI}/Font_LightAngle5.jpg`;
//             case 'Font_LightAngle6-Image':
//               return `https://report.gearvu.io/kiosk-image/downloaded_files/${data.IMEI}/Font_LightAngle6.jpg`;
//             case 'Font_LightAngle7-Image':
//               return `https://report.gearvu.io/kiosk-image/downloaded_files/${data.IMEI}/Font_LightAngle7.jpg`;
//             case 'Font_LightAngle8-Image':
//               return `https://report.gearvu.io/kiosk-image/downloaded_files/${data.IMEI}/Font_LightAngle8.jpg`;
//             case 'Front-Image':
//               return `https://report.gearvu.io/kiosk-image/downloaded_files/${data.IMEI}/Front.jpg`;

        
//             default: return '';
//           }
//         });

//         csvRows.push(row);
//       } catch (error) {
//         console.error(`Error fetching data for Report ID: ${report.reportId}`, error);
//       }
//     }

//     const csvContent = csvRows.map(row => row.join(',')).join('\n');
//     const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
//     const link = document.createElement('a');
//     link.href = URL.createObjectURL(blob);
//     link.setAttribute('download', 'exported_reports.csv');
//     document.body.appendChild(link);
//     link.click();
//     document.body.removeChild(link);
//   };

//   // Export QR codes
//   const exportQRCodes = async () => {
//     console.log("Starting exportQRCodes function...");
  
//     // Filter the selected reports based on checked items
//     const selectedReports = reports.filter((report) => checkedItems[report.reportId]);
//     console.log(`Selected Reports Count: ${selectedReports.length}`);
  
//     if (selectedReports.length === 0) {
//       alert("Please select at least one record to export.");
//       console.warn("No reports selected for QR code export.");
//       return;
//     }
  
//     const zip = new JSZip();
//     const folder = zip.folder("QRCodes");
  
//     const promises = selectedReports.map(async (report) => {
//       const qrCodeUrl = `https://report.gearvu.io/report/${report.reportId}`;
//       console.log(`Generating QR code for Report ID: ${report.reportId}, IMEI: ${report.imei}`);
//       console.log(`QR Code URL: ${qrCodeUrl}`);
  
//       try {
//         const qrCodeDataUrl = await QRCode.toDataURL(qrCodeUrl, { width: 300 });
//         console.log(`QR Code generated for IMEI ${report.imei}`);
        
//         const blob = await (await fetch(qrCodeDataUrl)).blob();
//         console.log(`QR Code blob fetched for IMEI ${report.imei}`);
        
//         folder.file(`${report.imei}.png`, blob);
//         console.log(`QR Code added to zip for IMEI ${report.imei}`);
//       } catch (error) {
//         console.error(`Failed to generate QR code for IMEI ${report.imei}:`, error);
//       }
//     });
  
//     await Promise.all(promises);
  
//     zip.generateAsync({ type: "blob" }).then((content) => {
//       console.log("ZIP file generated successfully.");
//       saveAs(content, "QRCodes.zip");
//       console.log("ZIP file download initiated.");
//     }).catch((error) => {
//       console.error("Failed to generate ZIP file:", error);
//     });
  
//     console.log("exportQRCodes function completed.");
//   };


//   const openUpdateModal = (report) => {
//     setSelectedReport(report);
//     setIsModalVisible(true);
//   };

//   // Function to handle modal close
//   const handleModalClose = () => {
//     setIsModalVisible(false);
//     setSelectedReport(null);
//   };


//   return (
//     <>     
//       <div className="App">
//         <div className="dashboard">
//           <div className="container-fluid">
//             <div className="row">
//               <Sidebar />
//               <div className="col-md-10 main">
//                 <h1 className="page-heading">Inventory Reports</h1>
//                 <div className='trade-in-search'>
//                   <div className="input-group">
//                     <div className="input-group-prepend">
//                       <span className="input-group-text"><img src={search} alt="Search" /></span>
//                     </div>
//                     <input
//                       type="text"
//                       className="form-control"
//                       placeholder="Enter IMEI/Report ID..."
//                       value={searchQuery}
//                       onChange={handleSearchChange}
//                     />
//                   </div>

//                   <div className="input-group">
//                     <RangePicker
//                       onChange={(dates) => setDateRange(dates || [null, null])}
//                       style={{ width: '100%' }}
//                       format="YYYY-MM-DD"
//                     />
//                   </div>
//                 </div>

//                 <section className="reports">
//                   <div className="container">
//                     <div className="row align-items-center">
//                       <div className="col-12">
//                         <Spin spinning={loading || isGhlLoading} size="large" wrapperClassName="custom-spin">
//                           <table className="table table-striped table-bordered align-items-center">
//                             <thead>
//                               <tr>
//                                 <th>
//                                   <Checkbox onChange={handleSelectAll} checked={selectAll} />
//                                   <span style={{ marginLeft: 8 }}>Select</span>
//                                 </th>
//                                 <th>ID</th>
//                                 <th>SKU</th>
//                                 <th>Date/Time</th>
//                                 <th>IMEI</th>
//                                 <th>Brand</th>
//                                 <th>Model</th>
//                                 <th>Grade</th>
//                                 {/* <th>Value ($)</th> */}
//                                 <th>In Stock</th>
//                                 <th>Status</th>
//                                 <th>Evaluate</th>  
//                                 <th>Details</th>
//                               </tr>
//                             </thead>
//                             <tbody>
//                               {currentReports.length > 0 ? (
//                                 currentReports.map((report) => {
//                                 let found = publishedReports?.find((rep)=>report?.imei===rep?.imei)
                                  
//                               return  <tr key={report.reportId}>
//                                     <td>
//                                       <Checkbox
//                                         checked={checkedItems[report.reportId]}
//                                         onChange={() => handleCheckboxChange(report.reportId)}
//                                         style={{
//                                           visibility: 'visible',
//                                           border: '2px solid black',
//                                           borderRadius: '4px',
//                                         }}
//                                       />
//                                     </td>
//                                     <td>{report.reportId}</td>
//                                     <td>{report.sku}</td>
//                                     <td>{report.reportDate}</td>
//                                     <td>{report.imei}</td>
//                                     <td>{report.brand}</td>
//                                     <td>{report.model}</td>
//                                     <td>{report.grade}</td>
//                                    <td>{report?.inStock ? report.inStock : 'YES'}</td>
//                                     {/* <td>{report.value}$</td> */}
//                                     <td>{report.status}</td>
//                                     <td>  
//                                 <button
//                                      className="btn btn-primary gr"                                     
//                                      onClick={() => openUpdateModal(report)}
//                                      disabled={report.grade}
//                                      style={{
//                                        backgroundColor: report.grade ? '#ccc' : '#007bff',
//                                        cursor: report.grade ? 'not-allowed' : 'pointer',
//                                      }}
//                                    >
                                   
//                                      {report.grade ? 'Graded' : 'Grade'}
//                                    </button>
//                                  </td>

//                                   <td>
//                                     <AntdTooltip title="View Report">
//                                     <Button
//                                     className="btn btn-primary gr"
//                                     onClick={() => openReportDetails(report.imei)}
//                                     icon={<EyeOutlined />} 
//                                   >                                
//                                   </Button> 
//                                   </AntdTooltip>

//                                       {/* <Button
//                                         // loading={isGhlLoading}
//                                         disabled={found?true:false}
//                                         className="btn btn-primary"
//                                         onClick={() => handleCreateReports(report)}
//                                       >
//                                         {found?'Report Published':'Publish Reports'}
//                                       </Button> */}
//                                     </td>
                                   
//                                   </tr>
//                                 }
//                               )
//                               ) : (
//                                 <tr>
//                                   <td colSpan="9" style={{ textAlign: 'center', padding: '20px' }}>
//                                     <Empty description="Oops! No reports found!" />
//                                   </td>
//                                 </tr>

//                               )}
//                             </tbody>
//                           </table>

//                         </Spin>

//                         <div className='table-bottom'>
//                            <Pagination
//                               current={currentPage}
//                               total={totalReports}
//                               pageSize={reportsPerPage}
//                               onChange={handlePageChange}
//                               showSizeChanger={false}
//                               showTotal={(total, range) =>
//                                 `${range[0]}-${range[1]} of ${total} reports`
//                               }
//                             />
//                           <button className="black" onClick={exportQRCodes}>Download QR Codes</button>
//                           <>
//                         <button className="black" onClick={handleExportClick}>Export as CSV</button>

//                         <Modal
//                           title="Select Fields to Export"
//                           visible={modalVisible}
//                           onOk={exportAsCSV}
//                           onCancel={() => setModalVisible(false)}
//                           width={600}
//                         >
//                           <div style={{ maxHeight: "400px", overflowY: "auto", padding: "10px" }}>
//                             <Checkbox onChange={handleSelectAllFields} checked={selectAllFields} style={{ fontWeight: "bold" }}>
//                               Select All
//                             </Checkbox>

//                             <Divider />

//                             <Row gutter={[16, 16]}>
//                               {allFields.map((field, index) => (
//                                 <Col span={12} key={index}>
//                                   <Checkbox
//                                     checked={selectedFields.includes(field)}
//                                     onChange={() => toggleFieldSelection(field)}
//                                     style={{ display: "flex", alignItems: "center", padding: "5px 0" }}
//                                   >
//                                     {field}
//                                   </Checkbox>
//                                 </Col>
//                               ))}
//                             </Row>
//                           </div>
//                         </Modal>
//                       </>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </section>
//               </div>
//             </div>
//           </div>
//         </div>

//         <div>
//           <Modal
//             title="Evaluate Report"
//             visible={isModalVisible}
//             onCancel={() => {
//               form.resetFields(); 
//               handleModalClose();
//             }}
//             footer={null}
//             className="evaluate-report-modal"
//           >
//             <Form
//               form={form}
//               layout="vertical"
//               onFinish={(values) => {
//                 handleUpdateReport(
//                   selectedReport?.reportId,
//                   values.grade,
//                   values.reason,
//                   values.imageLink,
//                   values.videoLink
//                 );
//                 form.resetFields();      
//                 handleModalClose();    
//               }}
//               initialValues={{
//                 grade: selectedReport?.grade ? String(selectedReport.grade) : undefined,
//                 reason: selectedReport?.reason ? String(selectedReport.reason) : undefined,
//                 imageLink: selectedReport?.imageLink ? String(selectedReport.imageLink) : undefined,
//                 videoLink: selectedReport?.videoLink ? String(selectedReport.videoLink) : undefined,
//               }}
//             >
//               <Form.Item
//                 label="Grade"
//                 name="grade"
//                 rules={[{ required: true, message: "Please select a grade!" }]}
//               >
//                 <Select placeholder="Select grade">
//                   <Select.Option value="1">1 (newPrice)</Select.Option>
//                   <Select.Option value="2">2 (goodPrice)</Select.Option>
//                   <Select.Option value="3">3 (badPrice)</Select.Option>
//                   <Select.Option value="4">4 (recyclePrice)</Select.Option>
//                 </Select>
//               </Form.Item>

//               <Form.Item
//                 label="Reason"
//                 name="reason"
//                 rules={[{ required: true, message: "Please provide a reason!" }]}
//               >
//                 <Input.TextArea placeholder="Enter reason for grade change" />
//               </Form.Item>

//               <Form.Item
//                 label="Image Link (Optional)"
//                 name="imageLink"
//                 rules={[
//                   {
//                     type: "url",
//                     message: "Please enter a valid URL!",
//                   },
//                   {
//                     message: "Please enter a valid image URL!",
//                   },
//                 ]}
//               >
//                 <Input.TextArea placeholder="Enter image link (if any)" />
//               </Form.Item>

//               <Form.Item
//                 label="Video Link (Optional)"
//                 name="videoLink"
//                 rules={[
//                   {
//                     type: "url",
//                     message: "Please enter a valid URL!",
//                   },
//                   {
                   
//                     message: "Please enter a valid video URL!",
//                   },
//                 ]}
//               >
//                 <Input.TextArea placeholder="Enter video link (if any)" />
//               </Form.Item>

//               <Form.Item>
//                 <button className="btn btn-primary" type="submit">
//                   Save
//                 </button>
//               </Form.Item>
//             </Form>
//           </Modal>
//       </div>
//       </div>
//     </>
//   );
// }

// export default DeviceReports;





